export const pages = {
  AdminGeneric: {
    label: "Admin - Generic",
  },
  menu: {
    label: "Menu",
    timesheets: "timesheets",
    invoices: "invoices",
    vendor: "vendor",
    client: "client",
    dashboard: "dashboard",
    administration: "administration",
    scopes: "scopes",
    users: "users",
    permissions: "permissions",
    languages: "languages",
    logs: "logs",
    jobs_logs: "jobs_logs",
    sms_logs: "sms_logs",
    help_center: "help_center",
    homepage: "homepage",
  },
  table: {
    label: "Tables",
    results: "results",
    items_per_page: "items_per_page",
    no_data_to_show: "no_data_to_show",
    test: "test",
  },
  form: {
    label: "Forms",
    select_option: "select_option",
    exist_field_error: "exist_field_error",
    admin_email_hays: "admin_email_hays",
    combination_exist_field_error: "combination_exist_field_error",
    notAssigned_language_error: "notAssigned_language_error",
    required_field_error: "required_field_error",
    upload_document_absence: "upload_document_absence",
    email_field_error: "email_field_error",
    email_field_error_unique: "email_field_error_unique",
    url_field_error: "url_field_error",
    alpha_field_error: "alpha_field_error",
    alphaNum_field_error: "alphaNum_field_error",
    numeric_field_error: "numeric_field_error",
    integer_field_error: "integer_field_error",
    decimal_field_error: "decimal_field_error",
    minLength_field_error: "minLength_field_error",
    maxLength_field_error: "maxLength_field_error",
    minValue_field_error: "minValue_field_error",
    maxValue_field_error: "maxValue_field_error",
    between_field_error: "between_field_error",
    sameAs_field_error: "sameAs_field_error",
    phone_field_error: "phone_field_error",
    nav_endpoint_field_error: "nav_endpoint_field_error",
    enter: "enter",
    choose_file: "choose_file",
    files_selected: "files_selected",
    password_field_error: "password_field_error",
    portal_url_error: "Portal Url already exists",
    freelancers_url_error: "Freelancers Url already exists"
  },
  button: {
    label: "Buttons",
    add: "add",
    next: "next",
    prev: "prev",
    remove: "remove",
    save: "save",
    submit: "submit",
    approver: "approver",
    rejecter: "rejecter",
    cancel_changes: "cancel_changes",
    cancel: "cancel",
    yes: "yes",
    no: "no",
    show_more: "show_more",
    not_now: "not_now",
    select_all: "select_all",
    deselect_all: "deselect_all",
    dropdown_select_label: "dropdown_select_label",
    dropdown_deselect_label: "dropdown_deselect_label",
    dropdown_selected_label: "dropdown_selected_label",
  },
  alerts: {
    label: "Alerts",
    success: "success",
    error: "error",
    success_operation: "success_operation",
    success_update: "success_update",
    unknown_error: "unknown_error",
    try_again_later: "try_again_later",
    redirecting_to_login_page: "redirecting_to_login_page",
    existing_email: "existing email",
    please_wait: "please_wait",
    dont_have_permission_msg: "dont_have_permission_msg",
    dont_have_nav_id: "dont_have_nav_id",
    too_large_file:"too_large_file",
    empty_file:"empty_file",
    file_not_supported: "file_not_supported",
    absence_not_remaining: "absence_not_remaining",
    not_allowed_to_access: "not_allowed_to_access",
    sms_delivery_error:"sms_delivery_error",
    max_total_size_exceeded:"max_total_size_exceeded",
    error_code: "error_code",
    url_not_found: "url_not_found",
    method_not_allowed: "method_not_allowed",
    unauthenticated: "unauthenticated",
    action_unauthorized: "action_unauthorized",
    no_results_found: "no_results_found",
    expired_token: "expired_token",
    invalid_token: "invalid_token",
    not_belong_to_scope: "not_belong_to_scope",
    language_not_changed_in_NAV: "language_not_changed_in_NAV",
    phone_not_changed_in_NAV: "phone_not_changed_in_NAV",
    sms_not_changed_in_NAV: "sms_not_changed_in_NAV",
    email_not_changed_in_NAV: "email_not_changed_in_NAV",
    invalid_NAV_credentials: "invalid_NAV_credentials",
    not_authorized_to_verify_phone: "not_authorized_to_verify_phone",
    invalid_input: "invalid_input",
    no_verification_code_for_this_phone: "no_verification_code_for_this_phone",
    sms_invalid_reciever: "sms_invalid_reciever",
    http_exception: "http_exception",
    sms_delivery_failed: "sms_delivery_failed",
    redirecting_to_other_scope: "redirecting_to_other_scope",
    internal_server_error: "internal_server_error",
    navision_no_response: "no_response",
    user_not_found_in_azure_ad_b2c: "user_not_found_in_azure_ad_b2c",
    nav_endpoint_not_accessible: 'nav_endpoint_not_accessible',
    invalid_freelancer_hours_per_day: 'invalid_freelancer_hours_per_day',
    invalid_hours_per_day: 'invalid_hours_per_day',
    invalid_total_std_hours: 'invalid_total_std_hours',
    err_client_used_in_timesheet_or_invoice: 'err_client_used_in_timesheet_or_invoice',
    used_client_cant_change_scope: 'used_client_cant_change_scope',
    clients_name_unique: 'clients_name_unique',
    cannot_export_timesheets:'cannot_export_timesheets'
  },
  AdminPage: {
    label: "Admin - Pages",
  },
  scope: {
    label: "Scopes",
    scopes: "scopes",
    list_of_scopes: "list_of_scopes",
    maintenance: "maintenance",
    live: "live",
    add_new_scope: "add_new_scope",
    update_new_scope: "update_new_scope",
    enter_name: "enter_name",
    name: "name",
    status: "status",
    default_language: "default_language",
    languages: "languages",
    scope_deleted: "scope_deleted",
    please_confirm: "please_confirm",
    please_wait: "please_wait",
    scope_added: "scope_added",
    scope_updated: "scope_updated",
    scope_nav_exist: "scope_nav_exist",
    scope_exist: "scope_exist",
    nav_endpoint: "nav_endpoint",
    nav_sharedKey: "nav_sharedKey",
    nav_scope_id: "nav_scope_id",
    enter_nav_scope_id: "enter_nav_scope_id",
    scope_logs: "scope_logs",
    jobs_logs: "jobs_logs",
    cci: "cci",
    portal_url: "portal_url",
    sms_logs: "sms_logs",
      enable_sms: "enable_sms",
      enable_email: "enable_email",
    properties_details: "Properties details for log",
    details: "Details for log",
    timezone: "Timezone",
    application_options: "application_options",
    is_timesheets_enabled: "is_timesheets_enabled",
    is_invoices_enabled: "is_invoices_enabled",
    scope_is_enabled: "scope_is_enabled",
    application_options_error: 'application_options_error',
    format_date: "Format date",
    scope_cannot_be_enabled: "scope_cannot_be_enabled",
    nav_status_failed: "nav_status_failed",
    smtp_check_failed: "smtp_check_failed",
    enabled: "enabled",
    disabled: "disabled",
    is_freelancers_enabled: 'is_freelancers_enabled',
    freelancers_url: 'freelancers_url',
    enter_freelancers_url: 'enter_freelancers_url',
    is_multirole_enabled: 'is_multirole_enabled',
    is_absences_enabled: 'is_absences_enabled',
    is_absences_per_days: 'is_absences_per_days',
    is_worked_hours_validation: 'is_worked_hours_validation',
    is_limiting_hours_of_work: 'is_limiting_hours_of_work'
  },
  scopeSettingDashboard: {
    label: "Scopes settings",
    scope: "scope",
    scope_settings: "scope_settings",
    help_page: "help_page",
    maintenance_page: "maintenance_page",
    error_page: "error_page",
    email_template_page: "email_template_page",
    nav_credentials: "nav_credentials",
    mail_credentials: "mail_credentials",
    emails: "emails",
    connectivity_test: "connectivity_test",
    monitoring_jobs: "monitoring_jobs",
    policies: "policies",
    sms_page: "sms_page",
    timesheet_config_page: "timesheet_config_page",
    config_cron_page: "config_cron_page",
    invoices: "invoices_page"
  },
  import_settings:{
    label: "import settings",
    import_settings_title: "import_settings_title",
    timesheet_cols_title: "timesheet_cols_title",
    vendors_name: "vendors_name",
    vendors_gp_id: "vendors_gp_id",
    timesheet_week_end_date: "timesheet_week_end_date",
    work_days_timesheet_work_date: "work_days_timesheet_work_date",
    contractor_name: "contractor_name",
    work_days_timesheet_earning_code: "work_days_timesheet_earning_code",
    work_days_timesheet_day_quantity: "work_days_timesheet_day_quantity",
    timesheet_status: "timesheet_status",
    timesheet_submitted_date: "timesheet_submitted_date",
    timesheet_approved_date: "timesheet_approved_date",
    sub_contractor_name: "sub_contractor_name",
    assignment_id: "assignment_id",
    work_days_project_id: "work_days_project_id",
    columns_updated: "columns_updated",
    invoice_cols_title: "invoice_cols_title",
    billing_term_category: "billing_term_category",
    currency: "currency",
    invoice_id: "invoice_id",
    billing_period: "billing_period",
    statement_date: "statement_date",
    timesheets_sub_contractor_name: "timesheets_sub_contractor_name",
    timesheets_contractor_name: "timesheets_contractor_name",
    timesheets_timesheet_week_end_date: "timesheets_timesheet_week_end_date",
    payments_pay_code: "payments_pay_code",
    timesheets_timesheet_id: "timesheets_timesheet_id",
    payments_units: "payments_units",
    payments_total_tax_amount: "payments_total_tax_amount",
    payments_net_supplier_payable: "payments_net_supplier_payable",
    assignment_start_date: "assignment_start_date",
    assignment_end_date: "assignment_end_date",
    timesheets_assignment_id: "timesheets_assignment_id",
    payments_project_id: "payments_project_id",
    payment_status : "PAYMENT_STATUS",
    client : "client",
  },
  settings: {
    label: "Menu",
    profile: "profile",
    change_password: "change_password",
    edit_email: "edit_email",
    sign_in: "sign_in",
    sign_out: "sign_out",
    add_provider_title: "add_provider_title",
    add_provider_description: "add_provider_description"
  },
  pageUsers: {
    label: "Users",
    id: "id",
    users: "users",
    name: "name",
    email: "email",
    roles: "roles",
    created_at: "created_at",
    updated_at: "updated_at",
    action: "action",
    list_of_users: "list_of_users",
    affect_role_scopes: "affect_role_scopes",
    role: "role",
    scopes: "scopes",
    user_updated: "user_updated",
    user_added: "user_added",
    default_scope: "default_scope",
    invitation_sent: "invitation_sent",
    invitation_expired: "invitation_expired",
    signup_completed: "signup_completed",
    resending_invitation: "resending_invitation",
    user_deleted: "user_deleted",
    last_actions: 'last_actions',
    notifications: 'notifications',
    enabled: "enabled",
    disabled: "disabled",
    reseting_password: "reseting_password"
  },
  pageUserDetails: {
    label: "User details",
    user_details: "user_details",
    personal_details: "personal_details",
    first_name: "first_name",
    last_name: "last_name",
    email: "email",
    phone: "phone",
    receive_sms: "receive_sms",
    system_details: "system_details",
    sign_up: "sign_up",
    invitation_expired: "invitation_expired",
    in_progress: "in_progress",
    completed: "completed",
    last_login: "last_login",
    portal_id: "portal_id",
    role: "role",
    roles: "roles",
    nav_id : "nav_id",
    scope_and_nav_id: "scope_and_nav_id",
    vendor_id_of_default_scope: "vendor_id_of_default_scope",
    scope_and_vendor_id: "scope_and_vendor_id",
    last_actions: "last_actions",
    last_notifications: "last_notifications",
    no_actions_found: "no_actions_found",
    actions_found: "actions_found",
    no_notifications_found: "no_notifications_found",
    notifications_found: "notifications_found",
    notification_data: "notification_data",
    show_data: "show_data",
    redirect_to_users_page: "redirect_to_users_page",
    filters: "filters",
    action_type: "action_type",
    template_type: "template_type",
    notification_type: "notification_type",
    date: "date",
  },
  language: {
    label: "Languages",
    flags: "flags",
    flag: "language_flag",
    title: "language_title",
    french: "french",
    english: "english",
    spanish: "spanish",
    italian: "italian",
    german: "german",
    name: "name",
    code: "code",
    nav_language_id: "nav_language_id",
    list_of_language: "list_of_language",
    languages: "languages",
    language_deleted: "language_deleted",
    language_updated: "language_updated",
    language_added: "language_added",
    language_nav_exist: "language_nav_exist",
    add_new_language: "add_new_language",
    update_new_language: "update_new_language",
    enter_code: "enter_code",
    enter_name: "enter_name",
    enter_nav_language_id: "enter_nav_language_id",
    dictionary: "dictionary",
    import_language_title: "import_language_title",
    import_language_button: "import_language_button",
  },
  client:{
    list_of_client:"list_of_client",
    client_added:"client_added",
    client_updated:"client_updated",
    client_deleted:"client_deleted",
    enter_client_name:"enter_client_name",
    add_new_client:"add_new_client",
    update_new_client:"update_new_client",
    client_name:"client_name",
    client_scope:"client_scope",
    client_status:"client_status",
    clients:"clients",
    timesheet_client_section_title:"timesheet_client_section_title",
  },
  permission: {
    label: "Permissions",
    permissions: "permissions",
    roles: "roles",
    permissions_per_role: "permissions_per_role",
    find_permission: "find_permission",
    select_role: "select_role",
    connect_as_approver: "connect_as_approver",
    connect_as_worker: "connect_as_worker",
    change_role: "change_role",
    connected_as: "connected_as"
  },
  maintenance: {
    label: "Maintenance page",
    maintenance: "maintenance",
    maintenance_page_title: "maintenance_page_title",
    maintenance_message_: "maintenance_message_"
  },
  error: {
    label: "Error page",
    error_page_title: "error_page_title",
    error_message_: "error_message_"
  },
  access_denied: {
    label: "Access denied page",
    access_denied_title: "access_denied_title",
    access_denied_description: "access_denied_description",
    freelancer_access_denied_description: "freelancer_access_denied_description",
    available_scopes: "available_scopes"
  },
  help_center: {
    label: "Help page",
    popular_questions: "popular_questions",
  },
  help_configuration: {
    label: "Help configuration",
    help_configuration_language_label: "help_configuration_language_label",
    help_configuration_page_title: "help_configuration_page_title",
    help_configuration_overview: "help_configuration_overview"
  },
  policies: {
    label: "policies",
    policies_page_title: "policies_page_title",
    privacy_policy: "privacy_policy",
    terms_and_conditions:"terms_and_conditions",
  },
  terms_and_conditions: {
    label: "Terms And Conditions",
    terms_and_conditions_title: "terms_and_conditions_title",
    terms_and_conditions_overview: "terms_and_conditions_overview",
    find_our_terms: "find_our_terms"
  },
  privacy_policy: {
    label: "Privacy Policy",
    privacy_policy_title: "privacy_policy_title",
    privacy_policy_overview: "privacy_policy_overview",
    find_our_privacy_policy: "find_our_privacy_policy"
  },
  email_template_configuration: {
    label: "Email templates' settings",
    test_email_button: "test_email_button",
    email_template_page_title: "email_template_page_title",
    no_template_selected_message: "no_template_selected_message",
    template_language_label: "template_language_label",
    email_subject_label: "email_subject_label",
    email_subject_placeholder: "email_subject_placeholder",
    email_refer_label: "Ref",
    email_refer_placeholder: "email_refer_placeholder",
    email_title_label: "email_title_label",
    email_title_placeholder: "email_title_placeholder",
    email_subtitle_label: "email_subtitle_label",
    email_subtitle_placeholder: "email_subtitle_placeholder",
    email_introduction_label: "email_introduction_label",
    email_introduction_placeholder: "email_introduction_placeholder",
    toolbar_variables: "toolbar_variables",
    email_button_description_label: "email_button_description_label",
    email_button_description_placeholder: "email_button_description_placeholder",
    email_button_principal: "email_button_principal",
    email_button_principal_label_placeholder: "email_button_principal_label_placeholder",
    email_button_review: "email_button_review",
    email_button_review_label_placeholder: "email_button_review_label_placeholder",
    email_button_approve: "email_button_approve",
    email_button_approve_label_placeholder: "email_button_approve_label_placeholder",
    email_button_reject: "email_button_reject",
    email_button_reject_label_placeholder: "email_button_reject_label_placeholder",
    email_ending_label: "email_ending_label",
    email_ending_placeholder: "email_ending_placeholder",
    worker_first_name: "worker_first_name",
    freelancer_first_name: "freelancer_first_name",
    worker_last_name: "worker_last_name",
    freelancer_last_name: "freelancer_last_name",
    company: "company",
    job: "job",
    contract_start_date: "contract_start_date",
    contract_end_date: "contract_end_date",
    timesheet_start_date: "timesheet_start_date",
    timesheet_end_date: "timesheet_end_date",
    approver_name: "approver_name",
    firstName: "firstName",
    lastName: "lastName",
    login: "login",
    password: "password",
    scopeHelpdeskEmail: "scope_helpdesk_email",
    signInUrl: "signInUrl",
    confirmationUrl: "confirmationUrl",
    verification_code: "verification_code",
    actualYear: "actualYear",
    general_email_templates: "general_email_templates",
    timesheets_email_templates: "timesheets_email_templates",
    invoices_email_templates: "invoices_email_templates",
    freelancer_email_templates: "freelancer_email_templates",
    contact_first_name: "contact_first_name",
    contact_last_name: "contact_last_name",
    contractor_full_name_n: "contractor_full_name_n",
    invoice_id_n: "invoice_id_n",
    billing_term_category_n: "billing_term_category_n",
    billing_period_n: "billing_period_n",
    statement_date_n: "statement_date_n",
    assignment_start_date_n: "assignment_start_date_n",
    assignment_end_date_n: "assignment_end_date_n",
    currency_n: "currency_n",

    timesheet_id_n: "timesheet_id_n",
    contractor_sub_name_n: "contractor_sub_name_n",
    assignment_id_n: "assignment_id_n",
    status_n: "status_n",
    submitted_date_n: "submitted_date_n",
    approved_date_n: "approved_date_n",
    display_item_details: "display_item_details",

    total_invoices: "total_invoices",
    invoices_to_create_count: "invoices_to_create_count",
    invoices_to_update_count: "invoices_to_update_count",
    total_timesheets: "total_timesheets",
    timesheets_to_create_count: "timesheets_to_create_count",
    timesheets_to_update_count: "timesheets_to_update_count",

    scopeId: 'scopeId',
    languageCode: 'languageCode',
    templateReference: 'templateReference',
    messageId: 'messageId',
    sendDate: 'sendDate',
  },
  general_email_templates_names: {
    label: "General email templates' titles",
    account_creation: "account_creation",
    email_confirmation: "email_confirmation"
  },
  timesheets_email_templates_names: {
    label: "Timesheets email templates' titles",
    timesheet_to_submit: "timesheet_to_submit",
    new_approval_permission_new_account: "new_approval_permission_new_account",
    new_contract_setup: "new_contract_setup",
    new_approval_permission: "new_approval_permission",
    pending_timesheet_reminder: "pending_timesheet_reminder",
    pending_timesheet: "pending_timesheet",
    timesheet_approved: "timesheet_approved",
    timesheet_rejected: "timesheet_rejected",
    timesheet_not_approved: "timesheet_not_approved"
  },
  invoices_email_templates_names: {
    label: "Invoices email templates' titles",
    monthly_invoice: "monthly_invoice",
    monthly_payment: "monthly_payment",
    weekly_timesheet_data: "weekly_timesheet_data",
    import_invoices_report_is_ready: "import_invoices_report_is_ready",
    import_timesheets_report_is_ready: "import_timesheets_report_is_ready",
  },
  email_template: {
    label: "Email templates' fields",
    email_tempalte_to: "email_tempalte_to",
    email_tempalte_cci: "email_tempalte_cci",
    email_template_contractNumber: "email_template_contractNumber",
    email_template_contractStartDate: "email_template_contractStartDate",
    email_template_contractEndDate: "email_template_contractEndDate",
    email_template_timesheetStartDate: "email_template_timesheetStartDate",
    email_template_timesheetSubmission: "email_template_timesheetSubmission",
    email_template_timesheet_id: "email_template_timesheet_id",
    email_template_approvers: "email_template_approvers",
    email_template_approvalFrequency: "email_template_approvalFrequency",
    email_template_worker: "email_template_worker",
    email_template_absence: "email_template_absence",
    email_template_overtime: "email_template_overtime",
    email_template_total_worked_hours: "email_template_total_worked_hours",
    email_template_workerName: "email_template_workerName",
    email_footer: "email_footer",
    freelancer_email_footer: "freelancer_email_footer",
    email_template_footer: "email_template_footer",
    freelancer_email_template_footer: "freelancer_email_template_footer",
    email_templates_general_type: "email_templates_general_type",
    email_templates_timesheets_type: "email_templates_timesheets_type",
    email_templates_invoices_type: "email_templates_invoices_type",
    email_templates_freelancer_type: "email_templates_freelancer_type",
  },
  freelancer_email_templates_names: {
    label: "Freelancer email templates' titles",
    freelancer_timesheet_to_submit: "freelancer_timesheet_to_submit",
    freelancer_new_contract_setup: "freelancer_new_contract_setup",
    freelancer_timesheet_approved: "freelancer_timesheet_approved",
    freelancer_timesheet_rejected: "freelancer_timesheet_rejected",
    freelancer_timesheet_not_approved: "freelancer_timesheet_not_approved",
  },
  nav_credentials: {
    label: "Navision credentials",
    nav_credentials_page_title: "nav_credentials_page_title",
    nav_end_point_label: "nav_end_point_label",
    nav_end_point_placeholder: "nav_end_point_placeholder",
    nav_shared_key_label: "nav_shared_key_label",
    nav_shared_key_placeholder: "nav_shared_key_placeholder",
    nav_username_label: "nav_username_label",
    nav_username_placeholder: "nav_username_placeholder",
    nav_password_label: "nav_password_label",
    nav_password_placeholder: "nav_password_placeholder",
  },
  mail_credentials: {
    label: "Mail credentials",
    mail_credentials_page_title: "mail_credentials_page_title",
    mail_credentials_oauth_title: "mail_credentials_oauth_title",
    mail_credentials_basic_auth_title: "mail_credentials_basic_auth_title",
    mail_credentials_oauth_description: "mail_credentials_oauth_description",
    mail_credentials_basic_auth_description: "mail_credentials_basic_auth_description",
    mail_host_label: "mail_host_label",
    mail_host_placeholder: "mail_host_placeholder",
    mail_port_label: "mail_port_label",
    mail_port_placeholder: "mail_port_placeholder",
    mail_username_label: "mail_username_label",
    mail_username_placeholder: "mail_username_placeholder",
    mail_password_label: "mail_password_label",
    mail_password_placeholder: "mail_password_placeholder",
    mail_test: "mail_test"
  },
  scope_emails: {
    label: "Scope emails",
    emails_page_title: "emails_page_title",
    it_helpdesk_label: "it_helpdesk_label",
    it_helpdesk_placeholder: "it_helpdesk_placeholder",
    admin_email_label: "admin_email_label",
    admin_email_placeholder: "admin_email_placeholder",
    cci_label: "cci_label",
    cci_placeholder: "cci_placeholder",
    test_email_label: "test_email_label",
    test_email_placeholder: "test_email_placeholder",
  },
  sms_configuration: {
    label: "sms notifications edit",
    sms_page_title: "sms_page_title",
    sms_template_page_title: "sms_template_page_title",
    sms_history_page_title: "sms_history_page_title",
    sms_allowed_countries_menu_title: "sms_allowed_countries_menu_title",
    sms_no_template_selected_message: "sms_no_template_selected_message",
    sms_template_language_label: "sms_template_language_label",
    sms_countries_label: "sms_countries_label",
    sms_allowed_countries_label: "sms_allowed_countries_label",
    sms_text_label: "sms_text_label",
    sms_text_placeholder: "sms_text_placeholder",
    sms_characters_number: "sms_characters_number",
    sms_number: "sms_number",
    sms_button_calculate: "sms_button_calculate",
    sms_test_button: "sms_test_button",
    sms_no_phone_error: "sms_no_phone_error",
    sms_credentials_page_title: "sms_credentials_page_title",
    sms_settings_page_title: "sms_settings_page_title",
    timesheets_sms_templates: "timesheets_sms_templates",
    freelancer_sms_templates: "freelancer_sms_templates"
  },
  sms_templates_names: {
    label: "sms notifications names",
    sms_pending_approval_reminder: "sms_pending_approval_reminder",
    sms_pending_submission_reminder: "sms_pending_submission_reminder",
    sms_rejected: "sms_rejected"
  },
  freelancer_sms_templates_names: {
    label: "freelancer sms notifications names",
    freelancer_sms_pending_approval_reminder: "freelancer_sms_pending_approval_reminder",
    freelancer_sms_pending_submission_reminder: "freelancer_sms_pending_submission_reminder",
    freelancer_sms_rejected: "freelancer_sms_rejected"
  },
  ovh_credentials: {
    label: "OVH credentials",
    ovh_credentials_page_title: "ovh_credentials_page_title",
    ovh_end_point_label: "ovh_end_point_label",
    ovh_end_point_placeholder: "ovh_end_point_placeholder",
    ovh_application_key_label: "ovh_application_key_label",
    ovh_application_key_placeholder: "ovh_application_key_placeholder",
    ovh_application_secret_label: "ovh_application_secret_label",
    ovh_application_secret_placeholder: "ovh_application_secret_placeholder",
    ovh_consumer_key_label: "ovh_consumer_key_label",
    ovh_consumer_key_placeholder: "ovh_consumer_key_placeholder",
    ovh_sender_label: "ovh_sender_label",
    ovh_sender_placeholder: "ovh_sender_placeholder",
    ovh_encoding_label: "ovh_encoding_label",
    ovh_encoding_placeholder: "ovh_encoding_placeholder",
    ovh_class_label: "ovh_class_label",
    ovh_class_placeholder: "ovh_class_placeholder",
    ovh_noStopClause_label: "ovh_noStopClause_label",
    ovh_noStopClause_placeholder: "ovh_noStopClause_placeholder",
  },
  connectivity_test: {
    label: "Test connectivity",
    connectivity_test_page_title: "connectivity_test_page_title",
    nav_request_sending: "nav_request_sending",
    nav_failure_message: "nav_failure_message",
    nav_success_message: "nav_success_message",
    smtp_request_sending: "smtp_request_sending",
    smtp_failure_message: "smtp_failure_message",
    smtp_success_message: "smtp_success_message",
    nav_test: "nav_test",
    test_nav_status: "test_nav_status",
    test_smtp_status: "test_smtp_status",
    monitoring_jobs: "monitoring_jobs",
    last_jobs: "Last jobs",
    pending_jobs: "Pending jobs",
    failed_jobs: "Failed jobs",
    failed_jobs_launched: "failed_jobs_launched",
    payload_details: "Payload details for job",
    exception_details: "Exception details for job",
    pending: "pending",
    failed: "failed",
    succeed: "succeed",
  },
  nav_status_history: {
    label: "Navision status history",
    nav_status_history_title: "nav_status_history_title",
    nav_status_test_date: "nav_status_test_date",
    nav_status_test_response_time: "nav_status_test_response_time",
    nav_status_test_result: "nav_status_test_result",
  },
    timesheet_config: {
        label: "Timesheet configuration",
        timesheet_config_page_title : "timesheet_config_page_title",
        timesheet_config_attachment: "timesheet_config_attachment",
        max_total_files_size_label: "max_total_files_size_label",
        max_total_files_size_label_placeholder: "max_total_files_size_label_placeholder",
        max_file_size_label: "max_file_size_label",
        max_file_size_label_placeholder: "max_file_size_label_placeholder",


    },
    cron_config: {
      label: "Cron configurations",
      cron_config_page_title: "cron_config_page_title",
      start_hour: "start_hour",
      end_hour: "end_hour",
      invalid_start_end_hour: "invalid_start_end_hour",
      days_of_week: "days_of_week"
    },
  timesheet: {
    label: "Timesheet",
    timesheet_start_date: "timesheet_start_date",
    timesheet_contract_number: "timesheet_contract_number",
    timesheet_id_number: "timesheet_id_number",
    timesheet_organisation: "timesheet_organisation",
    timesheet_worker_name: "timesheet_worker_name",
    timesheet_approver_name: "timesheet_approver_name",
    timesheet_role: "timesheet_role",
    timesheet_status: "timesheet_status",
    timesheet_approved: "timesheet_approved",
    timesheet_accepted: "timesheet_accepted",
    timesheet_paid: "timesheet_paid",
    timesheet_rejected: "timesheet_rejected",
    timesheet_pending_approval: "timesheet_pending_approval",
    timesheet_pending_submission: "timesheet_pending_submission",
    timesheet_submitted_date: "timesheet submitted at",
    timesheet_related: "related with invoice number",
    to_submit:"to_submit",
    to_submit_description: "to_submit_description",
    to_approve:"to_approve",
    to_approve_description: "to_approve_description",
    submitted:"submitted",
    submitted_description: "submitted_description",
    approved_title: "approved_title",
    approved_description: "approved_description",
    no_timesheet_message: "no_timesheet_message",
    approve_all_timesheet: "approve_all_timesheet",
    rejection_reason: "rejection_reason",
    approver_comment: "approver_comment",
    approver_l1_comment: "approver_L1_comment",
    globalComment: "globalComment",
    dailyComment: "dailyComment",
    total_time: "total_time",
    total_absences: "total_absences",
    overtime_comment_required: "overtime_comment_required",
    attachment_required: "attachment_required",
    rejection_reason_required: "rejection_reason_required",
    overtime_comment_too_long: "overtime_comment_too_long",
    timesheet_not_found: "timesheet_not_found",
    add_timesheet: "add_timesheet",
    edit_timesheet: "edit_timesheet",
    check_the_supported_files_list: "check_the_supported_files_list",
    allowed_extensions: "allowed_extensions",
    backward: "backward",
    forward: "forward",
    summary_button: "summary_button",
    reset_std: "reset_std",
    reset_info: "reset_info",
    abs_hours: "abs_hours"
  },
  invoice: {
    label: "Invoices list",
    invoices: "invoices_page_title",
    list_of_invoices: "list_of_invoices",
    add_invoice: "add_invoice",
    edit_invoice: "edit_invoice",
    invoice_payments_must_be_unique: "invoice_payments_must_be_unique",
    timesheet_id: "timesheet_id",
    project_id: "project_id",
    pay_code: "pay_code",
    total_tax_amount: "total_tax_amount",
    net_supplier_payable: "net_supplier_payable",
    units: "units",
    invoice_id: "invoice_id",
    billing_term_category: "billing_term_category",
    billing_period: "billing_period",
    currency: "currency",
    worker_full_name: "worker_full_name",
    payment_status: "payment_status",
    statement_date: "statement_date",
    assignment_start_date: "assignment_start_date",
    assignment_end_date: "assignment_end_date",

    enter_timesheet_id: "enter_timesheet_id",
    enter_project_id: "enter_project_id",
    enter_pay_code: "enter_pay_code",
    enter_total_tax_amount: "enter_total_tax_amount",
    enter_net_supplier_payable: "enter_net_supplier_payable",
    enter_units: "enter_units",
    enter_invoice_id: "enter_invoice_id",
    enter_billing_term_category: "enter_billing_term_category",
    enter_billing_period: "enter_billing_period",
    enter_currency: "enter_currency",
    enter_statement_date: "enter_statement_date",
    enter_assignment_start_date: "enter_assignment_start_date",
    enter_assignment_end_date: "enter_assignment_end_date",

    invoice_added: "invoice_added",
    invoice_updated: "invoice_updated",
    invoice_deleted: "invoice_deleted",
    invoice_payment_deleted: "invoice_payment_deleted",

    redirect_to_invoices_page: "redirect_to_invoices_page",
    rapport_title: "rapport_title",
    processed_invoices_rapport_title: "processed_invoices_rapport_title",
    rapport_total_invoices: "rapport_total_invoices",
    rapport_total_invoices_to_process: "rapport_total_invoices_to_process",
    rapport_invoices_to_create: "rapport_invoices_to_create",
    rapport_invoices_to_update: "rapport_invoices_to_update",
    rapport_import_invoices: "rapport_import_invoices",
    rapport_import_processed_invoices: "rapport_import_processed_invoices",
    rapport_total_invalid_invoices: "rapport_total_invalid_invoices",
    rapport_row: "rapport_row",
    rapport_invalid_email_col: "rapport_invalid_email_col",
    rapport_invalid_date_col: "rapport_invalid_date_col",
    rapport_invalid_numeric_col: "rapport_invalid_numeric_col",
    rapport_invalid_string_col: "rapport_invalid_string_col",
    rapport_invalid_currency_col: "rapport_invalid_currency_col",
    rapport_required_col: "rapport_required_col",
    rapport_timesheets_not_found: "rapport_timesheets_not_found",
    rapport_missing_columns: "rapport_missing_columns",
    rapport_invoices_is_pending: "rapport_invoices_is_pending"
  },
  invoice_details: {
    label: "Invoice details",

    page_title: "page_title",
    invoice_id: "invoice_id",
    invoice_created_date: "invoice_created_date",
    invoice_vendor_id: "invoice_vendor_id",
    invoice_vendor_name: "invoice_vendor_name",
    invoice_worker_name: "invoice_worker_name",
    invoice_payment_status: "invoice_payment_status",
    invoice_due_date: "invoice_due_date",
    invoice_timesheet_section_title: "invoice_timesheet_section_title",
    invoice_timesheet_id: "invoice_timesheet_id",
    invoice_timesheet_hours: "invoice_timesheet_hours",
    invoice_timesheet_end_date: "invoice_timesheet_end_date",
    invoice_assignment_section_title: "invoice_assignment_section_title",
    invoice_assignment_id: "invoice_assignment_id",
    invoice_assignment_bill_rate: "invoice_assignment_bill_rate",
    invoice_assignment_purchase_rate: "invoice_assignment_purchase_rate",
    invoice_payment_section_title: "invoice_payment_section_title",
    invoice_info_section_title: "invoice_info_section_title",
    invoice_vendor_section_title: "invoice_vendor_section_title",
    invoice_payment_msp_fee: "invoice_payment_msp_fee",
    invoice_payment_vms_fee: "invoice_payment_vms_fee",
    invoice_payment_amount_supplier: "invoice_payment_amount_supplier",
    invoice_payment_amount_client: "invoice_payment_amount_client",
    assignment_start_date: "assignment_start_date",
    assignment_end_date: "assignment_end_date",
    statement_date: "statement_date",
    payment_status: "payment_status",
    billing_term_category: "billing_term_category",
    billing_period: "billing_period",
    currency: "currency",
    units: "units",
    pay_code: "pay_code",
    net_supplier_payable: "net_supplier_payable",
    total_tax_amount: "total_tax_amount",
    project_id: "project_id",
    timesheets: "timesheets",
  },
  vendor_timesheets : {
    label: "Vendor Timesheets",

    vendor_timesheets_timesheets_title: "vendor_timesheets_timesheets_title",
    vendor_timesheets_timesheets_list: "vendor_timesheets_timesheets_list",

    vendor_timesheets_rapport_title: "vendor_timesheets_rapport_title",
    vendor_timesheets_rapport_success_title: "vendor_timesheets_rapport_success_title",
    vendor_timesheets_rapport_failed_title: "vendor_timesheets_rapport_failed_title",
    vendor_timesheets_rapport_total_timesheets: "vendor_timesheets_rapport_total_timesheets",
    vendor_timesheets_rapport_timesheets_to_create: "vendor_timesheets_rapport_timesheets_to_create",
    vendor_timesheets_rapport_timesheets_to_update: "vendor_timesheets_rapport_timesheets_to_update",
    vendor_timesheets_rapport_total_invalid_timesheets: "vendor_timesheets_rapport_total_invalid_timesheets",
    vendor_timesheets_rapport_missing_columns: "vendor_timesheets_rapport_missing_columns",
    vendor_timesheets_rapport_row: "vendor_timesheets_rapport_row",
    vendor_timesheets_rapport_import_timesheets: "vendor_timesheets_rapport_import_timesheets",
    vendor_timesheets_rapport_invalid_date_col: "vendor_timesheets_rapport_invalid_date_col",
    vendor_timesheets_rapport_invalid_numeric_col: "vendor_timesheets_rapport_invalid_numeric_col",
    vendor_timesheets_rapport_required_col: "vendor_timesheets_rapport_required_col",
    vendor_timesheets_report_is_pending: "vendor_timesheets_report_is_pending",
    open_pending_jobs: "open_pending_jobs",
  },
  vendor_timesheet_details: {
    label: "Vendor's timesheet details",

    vendor_timesheet_details_page_title: "vendor_timesheet_details_page_title",
    vendor_timesheet_details_vendor_name: "vendor_timesheet_details_vendor_name",
    vendor_timesheet_details_vendor_gp_id: "vendor_timesheet_details_vendor_gp_id",
    vendor_timesheet_details_assignment_id: "vendor_timesheet_details_assignment_id",
    vendor_timesheet_details_contractor_name: "vendor_timesheet_details_contractor_name",
    vendor_timesheet_details_sub_contractor_name: "vendor_timesheet_details_sub_contractor_name",
    vendor_timesheet_details_timesheet_status: "vendor_timesheet_details_timesheet_status",
    vendor_timesheet_details_timesheet_id: "vendor_timesheet_details_timesheet_id",
    vendor_timesheet_details_week_end_date: "vendor_timesheet_details_week_end_date",
    vendor_timesheet_details_submitted_date: "vendor_timesheet_details_submitted_date",
    vendor_timesheet_details_approved_date: "vendor_timesheet_details_approved_date",
    vendor_timesheet_details_days_section_title: "vendor_timesheet_details_days_section_title",
    vendor_timesheet_details_day_card_title: "vendor_timesheet_details_day_card_title",
    vendor_timesheet_details_work_date: "vendor_timesheet_details_work_date",
    vendor_timesheet_details_day_quantity: "vendor_timesheet_details_day_quantity",
    vendor_timesheet_details_earning_code: "vendor_timesheet_details_earning_code",
    vendor_timesheet_details_project_id: "vendor_timesheet_details_project_id",
  },
  UserProfile: {
    label: "User - Profile",
  },
  profile: {
    label: "Change Email",
    title: "profile_page_title",
    email: "email",
    current_email: "current_email",
    new_email: "new_email",
    enter_email: "enter_email",
    remove_new_email_error: "remove_new_email_error",
    required_email_error: "required_email_error",
    valid_email_error: "valid_email_error",
    email_to_confirm: "email_to_confirm",
    resend_email: "resend_email",
    are_you_sure: "are_you_sure",
    confirm_change_email_message: "confirm_change_email_message",
    confirm_change_email_button: "confirm_change_email_button",
    failed_request: "failed_request",
    changed: "changed",
    success_change_email_message: "success_change_email_message",
    success: "success",
    confirm_remove_email_message: "confirm_remove_email_message",
    confirm_remove_email_button: "confirm_remove_email_button",
    removed: "removed",
    success_remove_email_message: "success_remove_email_message",
    success_resend_code_message: "success_resend_code_message",
    enter_email_verification_code: "enter_email_verification_code",
    email_verification_code_modal_title: "email_verification_code_modal_title",
    email_verification_code_modal_content: "email_verification_code_modal_content",
    verification_code: "verification_code",
    enter_verification_code: "enter_verification_code",
    invalid_verification_code: "invalid_verification_code",
  },
  personalDetails: {
    label: "Personal data",
    personalDetails: "personalDetails",
    preferredLanguage: "preferredLanguage",
    full_name: "full_name",
    first_name: "first_name",
    last_name: "last_name",
    password: "password",
    re_password: "re_password",
    phone_number: "phone_number",
    firstName_placeholder: "firstName_placeholder",
    lastName_placeholder: "lastName_placeholder",
    email_placeholder: "email_placeholder",
    notAssigned_scope_error: "notAssigned_scope_error",

    personal_contacts_title: "personal_contacts_title",
    have_verification_code: "have_verification_code",
    verify_your_phone: "verify_your_phone",
    verification_code_description: "verification_code_description",
    invalid_verification_code: "invalid_verification_code",
    enable_sms_description: "enable_sms_description",
    vendor_gp_id: "vendor_gp_id",
    vendor_name: "vendor_name",
    nav_id: "nav_id",
    vendor_id_placeholder: "vendor_id_placeholder",
    nav_id_placeholder: "nav_id_placeholder",
    add_new_vendor: "add_new_vendor",
  },
  vendor: {
    label: "Vendor",
    vendor_list_of_timesheets: "vendor_list_of_timesheets",
    vendor_timesheet_deleted: "vendor_timesheet_deleted",
    vendor_dashboard: "vendor_dashboard",
    vendor_dashboard_page_title: "vendor_dashboard_page_title",
    vendor_timesheets: "vendor_timesheets",
    vendor_invoices: "vendor_invoices",
    timesheet: "timesheet",
    timesheet_id: "timesheet_id",
    timesheet_week_end_date: "timesheet_week_end_date",
    contractor_name: "contractor_name",
    sub_contractor_name: "sub_contractor_name",
    assignment_id: "assignment_id",
    timesheet_status: "timesheet_status",
    timesheet_submitted_date: "timesheet_submitted_date",
    timesheet_approved_date: "timesheet_approved_date",
    enter_timesheet_id: "enter_timesheet_id",
    enter_timesheet_week_end_date: "enter_timesheet_week_end_date",
    enter_contractor_name: "enter_contractor_name",
    enter_sub_contractor_name: "enter_sub_contractor_name",
    enter_assignment_id: "enter_assignment_id",
    enter_timesheet_submitted_date: "enter_timesheet_submitted_date",
    enter_timesheet_approved_date: "enter_timesheet_approved_date",
    enter_timesheet_status: "enter_timesheet_status",
    enter_vendor_gp_id: "enter_vendor_gp_id",
    enter_vendor_name: "enter_vendor_name",
    timesheet_vendor_section_title: "timesheet_vendor_section_title",
    work_days: "work_days",
    timesheet_work_date: "timesheet_work_date",
    enter_timesheet_work_date: "enter_timesheet_work_date",
    timesheet_earning_code: "timesheet_earning_code",
    enter_timesheet_earning_code: "enter_timesheet_earning_code",
    timesheet_day_quantity: "timesheet_day_quantity",
    enter_timesheet_day_quantity: "enter_timesheet_day_quantity",
    timesheet_added: "timesheet_added",
    timesheet_updated: "timesheet_updated",
    work_days_deleted: "work_days_deleted",
    redirect_to_timesheets_page: "redirect_to_timesheets_page",
    project_id: "project_id",
    enter_project_id: "enter_project_id",
    vendor_gp_id: "vendor_gp_id",
    add_new_vendor: "add_new_vendor",
    vendor_name: "vendor_name",
  },

  sign_up: {
    label: "Sign up",
    expired_token_message: "expired_token_message",
    invalid_token_message: "invalid_token_message",
    used_token_message: "used_token_message",
    resend_link_button: "resend_link_button",
    new_link_sent_message: "new_link_sent_message",
    sign_up_completed_message: "sign_up_completed_message",
    terms_and_conditions_link_text: "terms_and_conditions_link_text",
    privacy_policy_link_text: "privacy_policy_link_text",
    accept_terms_and_privacy_text_before_links: "accept_terms_and_privacy_text_before_links",
    accept_sms_text: "accept_sms_text",
    phone_verified: "phone_verified",
    sign_up_details: "sign_up_details",
    sign_up_contact: "sign_up_contact",
    sign_up_security: "sign_up_security",
  },
  allowed: {
    label: "Not allowed page",
    not_allowed: "not_allowed",
    not_allowed_access: "not_allowed_access",
  },
  common:{
    attachments:"attachments"
  },
  excel:{
    excel:"excel",
    import:"import",
    export:"export"
  }
}

